/**
 * Mega Menu Functionality
 */

export const initMegaMenu = () => {
    // Ensure jQuery is available
    const $ = window.jQuery || window.$;
    
    if (!$) {
        console.warn('jQuery is required for mega menu');
        return;
    }

    // Mobile mega menu toggle
    $(document).ready(function ($) {
        const $mobileToggle = $(".js-cats-mobile-toggle");
        const $megaMenuWrapper = $(".mega-menu-wrapper");
        const $megaMenuClose = $(".mega-menu-close");
        const $body = $("body");

        // Function to open mega menu
        const openMegaMenu = function() {
            if (window.innerWidth < 992) {
                $megaMenuWrapper.addClass("active");
                $body.addClass("mega-menu-open");
                // Prevent body scroll
                $body.css("overflow", "hidden");
            }
        };

        // Function to close mega menu
        const closeMegaMenu = function() {
            if (window.innerWidth < 992) {
                $megaMenuWrapper.removeClass("active");
                $body.removeClass("mega-menu-open");
                // Restore body scroll
                $body.css("overflow", "");
            }
        };

        // Handle mobile toggle click
        $mobileToggle.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            if (window.innerWidth < 992) {
                if ($megaMenuWrapper.hasClass("active")) {
                    closeMegaMenu();
                } else {
                    openMegaMenu();
                }
            }
        });

        // Handle close button click
        $megaMenuClose.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeMegaMenu();
        });

        // Close mega menu when clicking outside on mobile
        $(document).on("click", function (e) {
            if (window.innerWidth < 992) {
                if (!$megaMenuWrapper.is(e.target) && 
                    $megaMenuWrapper.has(e.target).length === 0 &&
                    !$mobileToggle.is(e.target) &&
                    $mobileToggle.has(e.target).length === 0 &&
                    !$megaMenuClose.is(e.target) &&
                    $megaMenuClose.has(e.target).length === 0) {
                    closeMegaMenu();
                }
            }
        });

        // Handle nested accordions for all sub-menu levels on mobile
        if (window.innerWidth < 992) {
            // Initialize: Hide all sub-menus and ensure all items with sub-menus have proper classes
            const initializeAccordions = function() {
                // Find ALL li elements that have a direct child .sub-menu
                $(".mega-menu-wrapper li").each(function() {
                    const $li = $(this);
                    const $subMenu = $li.find("> .sub-menu");
                    
                    if ($subMenu.length > 0) {
                        // Ensure menu-item-has-children class is present
                        if (!$li.hasClass("menu-item-has-children")) {
                            $li.addClass("menu-item-has-children");
                        }
                        
                        // Hide sub-menu by default (unless it's the first top-level one)
                        const isFirstTopLevel = $li.hasClass("menu-item-parent") && 
                                               $li.is(".main-mega-menu-list > .menu-item-parent:first-child");
                        
                        if (!isFirstTopLevel) {
                            $subMenu.removeClass("ShowChids");
                        }
                    }
                });
            };

            // Initialize on page load
            initializeAccordions();

            // Universal click handler - works exactly like menu-item-parent
            // Handle clicks on ALL .menu-item-has-children > a (same as menu-item-parent)
            $(document).on("click", ".mega-menu-wrapper .menu-item-has-children > a", function (e) {
                const $link = $(this);
                const $parent = $link.parent();
                const $subMenu = $parent.find("> .sub-menu");
                
                // Only prevent default and handle accordion if there's a submenu
                if ($subMenu.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Toggle active class (same as menu-item-parent)
                    $parent.toggleClass("active");
                    // Toggle ShowChids class on sub-menu (same as menu-item-parent)
                    $subMenu.toggleClass("ShowChids");
                }
                // If no sub-menu, allow normal link navigation
            });

            if (window.innerWidth < 992) {
                setTimeout(function () {
                    console.log($('.main-menu-col .main-mega-menu-list  .menu-item-has-children.active'))
                    $('.main-menu-col .main-mega-menu-list .menu-item-has-children.active > .sub-menu').removeClass('ShowChids');
                    $('.main-menu-col .main-mega-menu-list .menu-item-has-children.active').removeClass('active');
                }, 1000)
            }

            // Backup handler: Also catch any li with sub-menu that might not have menu-item-has-children class
            $(document).on("click", ".mega-menu-wrapper .sub-menu li > a", function (e) {
                const $link = $(this);
                const $parent = $link.parent();
                const $subMenu = $parent.find("> .sub-menu");
                
                // Only handle if there's a submenu and it's not already handled by menu-item-has-children handler
                if ($subMenu.length > 0 && !$parent.hasClass("menu-item-has-children")) {
                    // Ensure the class is present
                    $parent.addClass("menu-item-has-children");
                    e.preventDefault();
                    e.stopPropagation();
                    
                    $parent.toggleClass("active");
                    $subMenu.toggleClass("ShowChids");
                }
            });

            // Special handler for submenu-level-2 (depth 1 items with h4 structure)
            $(document).on("click", ".mega-menu-wrapper .submenu-level-2 > h4 > a", function (e) {
                const $submenuLevel2 = $(this).closest(".submenu-level-2");
                const $parentLi = $submenuLevel2.parent().parent();
                const $subMenu = $parentLi.find(".sub-menu").first();
                if ($subMenu.length > 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    $parentLi.toggleClass("active");
                    $subMenu.toggleClass("ShowChids");
                }
            });

            // Show first top-level submenu by default on mobile
            $(".main-mega-menu-list > .menu-item-parent").first().find("> .sub-menu").addClass("ShowChids");
            $(".main-mega-menu-list > .menu-item-parent").first().addClass("active");
        }
    });

    // Desktop mega menu functionality (only for screens wider than 768px)
    if (window.innerWidth > 768) {
        // For Handel Show SubMenu
        $(document).ready(function ($) {
            const $menuParents = $(".main-mega-menu-list > .menu-item-parent");

            // در ابتدا: فقط اولین زیرمنو فعال بشه
            $menuParents.first().find("> .sub-menu").addClass("ShowChids");

            // رویداد هاور برای آیتم‌های والد
            $menuParents.on("mouseenter", function () {
                // همه زیرمنوها کلاس ShowChids رو از دست بدن
                $menuParents.find("> .sub-menu").removeClass("ShowChids");

                // فقط زیرمنوی مربوط به این آیتم کلاس ShowChids بگیره
                $(this).find("> .sub-menu").addClass("ShowChids");
            });
        });

        // For Handel Show Mega Menu Parent And Btn Cat
        $(document).ready(function ($) {
            let timer;

            $(".mega-menu-trigger").on("mouseenter", function () {
                clearTimeout(timer);
                $(".mega-menu-wrapper").addClass("active");
                // $(".siteBlurOverlay").addClass("show");
            });

            $(".mega-menu-trigger").on("mouseleave", function () {
                timer = setTimeout(function () {
                    $(".mega-menu-wrapper").removeClass("active");
                    // $(".siteBlurOverlay").removeClass("show");
                }, 150);
            });

            $(".mega-menu-wrapper").on("mouseenter", function () {
                clearTimeout(timer);
            });

            $(".mega-menu-wrapper").on("mouseleave", function () {
                timer = setTimeout(function () {
                    $(".mega-menu-wrapper").removeClass("active");
                    // $(".siteBlurOverlay").removeClass("show");
                }, 150);
            });
        });
    }

    // Handle window resize to update behavior
    let resizeTimer;
    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // Close mobile menu if resizing to desktop
            if (window.innerWidth >= 992) {
                $(".mega-menu-wrapper").removeClass("active");
                $("body").removeClass("mega-menu-open").css("overflow", "");
            }
        }, 250);
    });
};
